import { render, staticRenderFns } from "./NoticeOrderMayang.vue?vue&type=template&id=09e0573e&scoped=true&"
import script from "./NoticeOrderMayang.vue?vue&type=script&lang=js&"
export * from "./NoticeOrderMayang.vue?vue&type=script&lang=js&"
import style0 from "./NoticeOrderMayang.vue?vue&type=style&index=0&id=09e0573e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0573e",
  null
  
)

export default component.exports